import SharedPropsService from "../../SharedPropsService";
import { ROUTE } from "../../routes";
import { platformApi, StoreKey } from "../../configs/api";
import { CreditApplicationState, VoltWebSiteBaseLink } from "../../configs/constants";
import { ActiveCustomerTableBuilder, rebuildActiveCustomerMobileCardBuilder, searchObject, sideBarNavigate, } from "../dashboard/utils";
import { rebuildActiveCustomerTable } from "../utils";
import { getAppHeader } from "../../configs/config";
import { ColorTokens, WIDGET } from "@voltmoney/schema";
const PartnerActiveCustomerDataOriginal = {
    activeCustomerDetails: [],
    nextToken: null,
};
let PartnerActiveCustomerData;
let tableSearchString_AC = '';
let ascOrder = true;
let newCounter = 1;
let array;
let appendArray = [];
let appendDefinedValues = [];
export const onSearchActiveCustomer = async (action, _datastore, standardUtilites) => {
    tableSearchString_AC = action.payload.value;
    const activeCustomersFromSP = await SharedPropsService.getActiveCustomersList();
    if (tableSearchString_AC === "") {
        await standardUtilites.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "activeCustomerTable", {
            titleMap: {
                ...ActiveCustomerTableBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...ActiveCustomerTableBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ActiveCustomerTableBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await standardUtilites.appendWidgets(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, {
            ...ActiveCustomerTableBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === 1) {
            await standardUtilites.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "activeCustomerTable", {
                titleMap: {
                    ...ActiveCustomerTableBuilder(activeCustomersFromSP.slice(0, 50)).Title_MAP,
                },
                titleConfig: {
                    ...ActiveCustomerTableBuilder(activeCustomersFromSP.slice(0, 50))
                        .TITLE_CONFIG,
                },
                widgetData: {
                    ...ActiveCustomerTableBuilder(activeCustomersFromSP.slice(0, 50)).DATA,
                },
                data: activeCustomersFromSP.slice(0, 50),
            });
            await standardUtilites.appendWidgets(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, {
                ...ActiveCustomerTableBuilder(activeCustomersFromSP.slice(0, 50)).DATA_STORE,
            }, [
                {
                    id: "referredPartnerTableStack11", type: WIDGET.STACK
                }
            ], "spaceStack");
        }
    }
    else {
        PartnerActiveCustomerData = activeCustomersFromSP.filter(data => {
            if (searchObject(data, tableSearchString_AC) &&
                searchObject(data, tableSearchString_AC).length > 0) {
                return true;
            }
            else {
                return false;
            }
        });
        if (action?.payload?.widgetId === 'activeCustomerMobRootSearchInput') {
            await rebuildActiveCustomerMobileCardBuilder(standardUtilites, PartnerActiveCustomerData);
        }
        else {
            await rebuildActiveCustomerTable(standardUtilites, PartnerActiveCustomerData);
        }
    }
};
export const onSortActiveCustomer = async (action, _datastore, standardUtilites) => {
    console.warn('**** onSortActiveCustomer Action Triggered ****', action);
    // PartnerActiveCustomerData = sortPartnerObjectByProperty (
    //     PartnerActiveCustomerData,
    //     action.payload.value,
    //     ascOrder,
    // )
    ascOrder = !ascOrder;
    //await rebuildActiveCustomerTable(standardUtilites, PartnerActiveCustomerData, action, partnerAccountType);
};
export const onLoadActiveCustomer = async (action, _datastore, { network, goBack, setDatastore }) => {
    console.warn('**** onLoadActiveCustomer Action Triggered ****', action);
    const response = await network.get(`${platformApi.activeCustomers}`, {
        headers: await getAppHeader()
    });
    if (response.status === 200) {
        PartnerActiveCustomerDataOriginal['activeCustomerDetails'] = response?.data?.activeCustomerDetails.filter((item, index) => {
            if (item?.creditApplication?.applicationState !== CreditApplicationState.COMPLETED) {
                return true;
            }
            return false;
        });
        PartnerActiveCustomerDataOriginal['activeCustomerDetails'] = response?.data?.activeCustomerDetails;
    }
};
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    console.warn('**** onChangeTabAC Action Triggered ****', action);
    await sideBarNavigate(standardUtilities, action);
};
export const onTrackCustomerJourney = async (action, _datastore, standardUtilities) => {
    console.warn('**** onTrackCustomerJourney leads Action Triggered ****', action);
    const user = action.payload.value;
    const borrowerAccountId = user?.creditApplication?.accountId;
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId });
};
export const viewDetails = async (action, _datastore, standardUtilities) => {
    console.warn('**** viewDetails Action Triggered ****', action);
    const user = action?.payload.user;
    if (user) {
        standardUtilities.navigate(ROUTE.PLATFORM_VIEW_DETAILS, { user: user, activeCustomer: true });
    }
};
export const onShareLinkWithRef = async (action, _datastore, standardUtilities) => {
    standardUtilities.instrumentTrack("INVITE_CLIENT_BUTTON CLICKED", {
        "page": "active_customers"
    });
    console.warn('**** onShareLinkWithRef Action Triggered ****', action);
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const refCode = user?.linkedPartnerAccounts[0]?.partnerCode;
    const link = `${VoltWebSiteBaseLink}?ref=${refCode}`;
    standardUtilities.navigate(ROUTE.INVITE_CLIENT, { _link: link });
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        isFromPlatform: true,
        routeId: action?.routeId
    });
};
export const onRegisterLeads = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
        "page": "active_customer"
    });
    await navigate(ROUTE.REGISTER_LEADS, {});
};
export const appendCounter = async (action, _datastore, { setDatastore, appendWidgets }) => {
    array = action.payload.array;
    const totalNoOfPages = action.payload.totalNoOfPages;
    if (newCounter !== totalNoOfPages) {
        newCounter = newCounter + 1;
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "nextText", {
            color: ColorTokens.Grey_Night
        });
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "rightIcon", {
            color: ColorTokens.Grey_Night
        });
        if (newCounter > 1) {
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "previousText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "leftIcon", {
                color: ColorTokens.Grey_Night
            });
        }
        else {
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "previousText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "leftIcon", {
                color: ColorTokens.Grey_Charcoal
            });
        }
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "currentPageNumber", {
            label: `Page ${newCounter}`,
        });
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "spaceStack", {
            hide: false
        });
        const pageNumber = newCounter;
        const valuesToShowPerPage = 50;
        const startValue = (pageNumber - 1) * valuesToShowPerPage + 1;
        const endValue = pageNumber * valuesToShowPerPage;
        appendArray = [];
        for (let i = startValue; i <= endValue; i++) {
            appendArray.push(array[i]);
        }
        appendDefinedValues = appendArray.filter((value) => value !== undefined);
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "activeCustomerTable", {
            titleMap: {
                ...ActiveCustomerTableBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...ActiveCustomerTableBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ActiveCustomerTableBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await appendWidgets(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, {
            ...ActiveCustomerTableBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === totalNoOfPages) {
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "nextText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "rightIcon", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "previousText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "leftIcon", {
                color: ColorTokens.Grey_Night
            });
        }
    }
    else {
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "nextText", {
            color: ColorTokens.Grey_Charcoal
        });
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "rightIcon", {
            color: ColorTokens.Grey_Charcoal
        });
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "previousText", {
            color: ColorTokens.Grey_Night
        });
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "leftIcon", {
            color: ColorTokens.Grey_Night
        });
    }
};
export const minusCounter = async (action, _datastore, { setDatastore, appendWidgets }) => {
    if (newCounter > 1) {
        newCounter = newCounter - 1;
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "currentPageNumber", {
            label: `Page ${newCounter}`,
        });
        const pageNumber = newCounter;
        const valuesToShowPerPage = 50;
        const startValue = (pageNumber - 1) * valuesToShowPerPage + 1;
        const endValue = pageNumber * valuesToShowPerPage;
        appendArray = [];
        for (let i = startValue; i <= endValue; i++) {
            console.log(i);
            appendArray.push(array[i]);
        }
        appendDefinedValues = appendArray.filter((value) => value !== undefined);
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "activeCustomerTable", {
            titleMap: {
                ...ActiveCustomerTableBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...ActiveCustomerTableBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ActiveCustomerTableBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "spaceStack", {
            hide: false
        });
        await appendWidgets(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, {
            ...ActiveCustomerTableBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === 1) {
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "previousText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "leftIcon", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "nextText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, "rightIcon", {
                color: ColorTokens.Grey_Night
            });
        }
    }
};
